import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { SecondaryButton } from "./Button";
import ImageContainer from "./ImageContainer";
import styled from "styled-components";

export interface TableProps {
  items: Array<any>;
  headers: Array<any>;
  pagination?: boolean;
  childHeaders?: Array<any>;
  expandedRows?: any;
  errorImg?: any;
  actionLabel?: string;
  icon?: string;
  loading?: boolean;
  lazyLoading?: boolean;
  icon_alt?: string;
  alertSvg?: any;
  alertSvg_alt?: any;
  rows?: number;
  totalItems?: number;
  getMoreData?: (page?: number, resultsPerPage?: number) => Promise<void>;
  onActionClick?: (a: any) => void;
  onNotificationClick?: (a: any) => void;
  onExpandRow?: (a: any) => void;
}

const MyDetail = styled(DataTable)`
  table {
    table-layout: auto !important;
  }
  .p-paginator .p-paginator-current,
  .p-paginator-prev,
  .p-paginator-next {
    margin: 0;
  }
  .p-paginator-prev,
  .p-paginator-next {
    color: #dd052b;
    border: 1px solid #d9d9d9;
    background-color: white;
  //  box-shadow: 0px 3px 6px #00000029;
    font-size: 1rem;
    padding: 0.5rem;
    &:hover {
      cursor: pointer;
      color: #dd052b !important;
      background-color: white !important;
    }
  }
  .p-paginator-current {
    border: 1px solid #d9d9d9;
    background-color: white;
    box-shadow: 0px 3px 6px #00000029;
    padding: 1rem;
    &:hover {
      cursor: default;
    }
  }
  .p-paginator-bottom {
    padding: 1.5rem 0 !important;
  }
  .p-datatable-tbody td,
  .p-datatable-thead th {
    color: #484848;
   // text-align: center;
    padding: 1.2rem !important;
  }
  .p-datatable-thead th {
    background: white !important;
    color: #052e6d !important;
  }
  .p-datatable-thead tr {
    box-shadow: 0px 2px 10px #00000010;
  }
  .p-datatable-tbody > tr > td {
    padding: 0.9rem 1.2rem !important;
  }
  .p-datatable-tbody > tr {
    .td-icon-error {
      padding-top: 0px !important;
      padding-bottom: 0px !important;
    }
    .td-text-movements {
      padding-top: 0px !important;
      padding-bottom: 0px !important;
    }
  }
  .p-datatable-tbody > tr > td .p-row-toggler {
    color: #dd052b !important;
    padding: 0 1.2rem !important;
    height: 15px;
    &:focus {
      box-shadow: none;
    }
  }
  .p-paginator-element {
    &:hover {
      border: 1px solid gray !important;
    }
    &:focus {
      box-shadow: none;
    }
  }
  .p-datatable-tbody > tr > td .p-row-toggler:enabled:hover,
  .p-datatable-tbody > tr > td .p-row-editor-init:enabled:hover,
  .p-datatable-tbody > tr > td .p-row-editor-save:enabled:hover,
  .p-datatable-tbody > tr > td .p-row-editor-cancel:enabled:hover {
    background: white !important;
  }
  /* .p-link:focus {
    box-shadow: unset !important;
  } */
`;

const ChildTable = styled(DataTable)`
   left:60px;
   width:calc(100% - 60px);
  .p-datatable-thead th {
   display:none!important;
  }
  .p-datatable-scrollable-header {
    display: none !important;
  }
`;

const Data = styled(DataTable)`
  table {
    table-layout: auto !important;
  }
  .p-paginator .p-paginator-current,
  .p-paginator-prev,
  .p-paginator-next {
    margin: 0;
  }
  .p-paginator-prev,
  .p-paginator-next {
    color: #dd052b;
    border: 1px solid #d9d9d9;
    background-color: white;
  //  box-shadow: 0px 3px 6px #00000029;
    font-size: 1rem;
    padding: 0.5rem;
    &:hover {
      cursor: pointer;
      color: #dd052b !important;
      background-color: white !important;
    }
  }
  .p-paginator-current {
    border: 1px solid #d9d9d9;
    background-color: white;
    box-shadow: 0px 3px 6px #00000029;
    padding: 1rem;
    &:hover {
      cursor: default;
    }
  }
  .p-paginator-bottom {
    padding: 1.5rem 0 !important;
  }
  .p-datatable-tbody td,
  .p-datatable-thead th {
    color: #484848;
    text-align: center;
  }
  .p-datatable-thead th {
    background: white !important;
    color: #052e6d !important;
  }
  .p-datatable-thead tr {
    box-shadow: 0px 2px 10px #00000010;
  }
  .p-datatable-tbody > tr > td {
    padding: 0 1rem !important;
  }
  .p-datatable-tbody tr:nth-child(even) {
    background-color: #f3f3f3;
  }
  .p-datatable-tbody tr:nth-child(odd) {
    background-color: #ffffff;
  }
`;

const BasicTable = styled(DataTable)`
  table {
    table-layout: auto !important;
  }
  .p-paginator .p-paginator-current,
  .p-paginator-prev,
  .p-paginator-next {
    margin: 0;
  }
  .p-paginator-prev,
  .p-paginator-next {
    color: #dd052b;
    border: 1px solid #d9d9d9;
    background-color: white;
   // box-shadow: 0px 3px 6px #00000029;
    font-size: 1rem;
    padding: 0.5rem;
    &:hover {
      cursor: pointer;
      color: #dd052b !important;
      background-color: white !important;
    }
  }
  .p-paginator-current {
    border: 1px solid #d9d9d9;
    background-color: white;
    box-shadow: 0px 3px 6px #00000029;
    padding: 1rem;
    &:hover {
      cursor: default;
    }
  }
  .p-paginator-bottom {
    padding: 1.5rem 0 !important;
  }
  .p-datatable-tbody td,
  .p-datatable-thead th {
    color: #484848;
    text-align: center;
  }
  .p-datatable-thead th {
    background: white !important;
    color: #052e6d !important;
  }
  .p-datatable-thead tr {
    box-shadow: 0px 2px 10px #00000010;
  }
  .p-datatable-tbody > tr > td {
    padding: 1.3rem !important;
  }
  .p-datatable-tbody tr:nth-child(even) {
    background-color: #f3f3f3;
  }
  .p-datatable-tbody tr:nth-child(odd) {
    background-color: #ffffff;
  }
`;

const NotificationButton = styled.button`
  text-align: center;
  cursor: pointer;
  background-color: transparent;
  border: none;
  outline: none;
`;

const errorTemplate = (rowData, img) => {
  if (rowData.error) {
    return <ImageContainer image={img} />;
  }
};

const rowClassError = (row) => {
  return {
    "row-error": row.type !== "Bajada" && row.type !== "Subida" && row.type !== 'Baixada' && row.type !== 'Pujada',
    "row-detail": row.type === "Bajada" || row.type === "Subida" || row.type === 'Baixada' || row.type === 'Pujada',
  };
};

const rowClassType = (row) => {
  return {
    "row-type":
      row && row.info && row.info.data && row.info.data.cancellations === null,
  };
};

const rowExpansionTemplate = (data: any, headers: Array<any>) => {
  return (
    <>
      {data && data.info && data.info.data && data.info.data.cancellations ? (
        <ChildTable
          rowClassName={rowClassError}
          value={data.info.data.cancellations}
        >
          {headers &&
            headers.map((header, index) => {
              return <Column key={index} field={header.id} />;
            })}
        </ChildTable>
      ) : null}
    </>
  );
};

const templateRow = (
  row: any,
  header: any,
  actionLabel: string,
  icon: string,
  icon_alt: string,
  alertSvg: any,
  alertSvg_alt: any,
  onActionClick: any,
  onNotificationClick?: any,
) => {
  const element = row[header.id];
  if (typeof element === "boolean") {
    if (header.id === "notifications") {
      return (
        <NotificationButton
          data-testid="notification-button"
          onClick={() => onNotificationClick({ row: row, checked: !element })}
        >
          <img src={element ? alertSvg : alertSvg_alt} />
        </NotificationButton>
      );
    } else return element ? "Si" : "No";
  } else if (header.id === "action") {
    return (
      <SecondaryButton
        onClick={() => onActionClick(row)}
        text={actionLabel ? actionLabel : ""}
        icon={`pi pi-${row.added ? icon_alt : icon}`}
      />
    );
  } else return element;
};

export const DetailTable: React.FC<TableProps> = ({
  items,
  headers,
  childHeaders,
  pagination,
  errorImg,
  expandedRows,
  totalItems,
  rows,
  getMoreData,
  onExpandRow,
}) => {
  const [dataSource, setDataSource] = useState(items);
  const [products, setProducts] = useState(dataSource.slice(0, rows));
  const [first, setFirst] = useState(0);
  const [loading, setLoading] = useState(false);
  const [numberPag, setNumberPag] = useState(1);

  const paginationEntire = (totalItems / rows) % 1 == 0 ? 0 : 1;
  const totalPages = Math.trunc(totalItems / rows) + paginationEntire;

  const onPage = async (event: any) => {
    const startIndex = event.first;
    const endIndex = event.first + rows;
    
    if (startIndex >= items.length) {
      setLoading(true);
      const page = numberPag + 1;
      await getMoreData(page).then(() => {
        setNumberPag(page);
        setLoading(false);
      });
    }
    setFirst(startIndex);
    setProducts(dataSource.slice(startIndex, endIndex));
  }

  return (
    <MyDetail
      style={{ border: "1px solid #E8E8E8" }}
      rowClassName={rowClassType}
      value={products}
      rows={rows || 10}
      loading={loading}
      first={first}
      lazy
      totalRecords={totalItems}
      currentPageReportTemplate={`{currentPage} de ${totalPages}`}
      paginatorTemplate="PrevPageLink CurrentPageReport NextPageLink"
      paginator={pagination}
      expandedRows={expandedRows}
      onPage={onPage}
      onRowToggle={(e: any) => onExpandRow(e.data)}
      rowExpansionTemplate={(data) => rowExpansionTemplate(data, childHeaders)}
    >
      <Column expander style={{ width: "3rem" }} data-testid="expander" aria-labelledby="expandir" />
      {headers &&
        headers.map((header, index) => {
          if (header.id === "error") {
            return (
              <Column
                className="td-icon-error"
                style={{
                  width: "3rem",
                }}
                key={index}
                header=""
                body={(data) => errorTemplate(data, errorImg)}
              />
            );
          }
          if (header.id === "movements" || header.id === "operationDate") {
            return (
              <Column
                className={header.id === "movements" ? "td-text-movements" : ""}
                style={{ width: header.id === "movements" ? "19rem" : "10rem" }}
                key={index}
                field={header.id}
                header={header.label}
              />
            );
          }
          return <Column className="text-right" key={index} field={header.id} header={header.label} />;
        })}
    </MyDetail>
  );
}

export const TableData: React.FC<TableProps> = ({
  items,
  headers,
  actionLabel,
  icon,
  loading,
  lazyLoading,
  icon_alt,
  alertSvg,
  alertSvg_alt,
  rows,
  onActionClick,
  onNotificationClick,
}) => (
  <>
    <Data
      style={{ border: "1px solid #E8E8E8" }}
      value={items}
      lazy={lazyLoading ? lazyLoading : false}
      loading={lazyLoading && loading}
      rows={rows ? rows : 10}
      currentPageReportTemplate="{currentPage} de {totalPages}"
      paginatorTemplate="PrevPageLink CurrentPageReport NextPageLink"
      paginator
    >
      {headers &&
        headers.map((header, index) => {
          return (
            <Column
              key={index}
              field={header.id}
              header={header.label}
              body={(row) =>
                templateRow(
                  row,
                  header,
                  actionLabel,
                  icon,
                  icon_alt,
                  alertSvg,
                  alertSvg_alt,
                  onActionClick,
                  onNotificationClick,
                )
              }
            />
          );
        })}
    </Data>
  </>
);

export const Basic: React.FC<TableProps> = ({ items, headers, rows }) => (
  <>
    <BasicTable
      style={{ border: "1px solid #E8E8E8" }}
      value={items}
      rows={rows ? rows : 10}
      currentPageReportTemplate="{currentPage} de {totalPages}"
      paginatorTemplate="PrevPageLink CurrentPageReport NextPageLink"
      paginator
    >
      {headers &&
        headers.map((header, index) => {
          return <Column key={index} field={header.id} header={header.label} />;
        })}
    </BasicTable>
  </>
);
